import { useState } from 'react';

import Icon from '../../../components/AppIcon';
import QuestionCard from './QuestionCard';

const DurationStep = ({ formData, onUpdate }) => {
  const [selectedDuration, setSelectedDuration] = useState(formData?.duration || '');

  const durations = [
    { value: '1', label: 'ساعة واحدة', description: 'مناسب للجلسات القصيرة' },
    { value: '2', label: 'ساعتان', description: 'الأكثر شيوعاً للجلسات العادية' },
    { value: '3', label: '3 ساعات', description: 'جلسات متوسطة الطول' },
    { value: '4', label: '4 ساعات', description: 'جلسات طويلة ومفصلة' },
    { value: '6', label: '6 ساعات', description: 'تغطية نصف يوم' },
    { value: '8', label: '8 ساعات', description: 'تغطية يوم كامل' },
    { value: '10', label: '10 ساعات', description: 'تغطية ممتدة' },
  ];

  const handleDurationChange = (value, label) => {
    setSelectedDuration(value);
    const selectedDurationObj = durations.find(d => d.value === value);
    onUpdate({ 
      duration: value,
      durationLabel: label || selectedDurationObj?.label || value
    });
  };

  const getDurationRecommendation = () => {
    const duration = parseInt(selectedDuration);
    if (duration <= 2) return 'مناسب للجلسات السريعة والتصوير الشخصي';
    if (duration <= 4) return 'مثالي لمعظم أنواع التصوير والفعاليات';
    if (duration <= 8) return 'مناسب للفعاليات الكبيرة وحفلات الزفاف';
    return 'تغطية شاملة للفعاليات الممتدة والمناسبات الخاصة';
  };

  return (
    <QuestionCard
      icon="Clock"
      title="كم ساعة تحتاج للتصوير؟"
      description="المدة الزمنية تؤثر بشكل مباشر على التكلفة النهائية"
    >
      <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
        {durations?.map((duration) => (
          <button
            key={duration?.value}
            onClick={() => handleDurationChange(duration?.value, duration?.label)}
            className={`p-5 rounded-xl border-2 text-center transition-all hover:border-primary hover:bg-primary/5 ${
              formData?.duration === duration?.value
                ? 'border-primary bg-primary/10 shadow-sm'
                : 'border-border bg-background'
            }`}
          >
            <div className="text-2xl font-bold text-primary mb-1">
              {duration?.label}
            </div>
            <div className="text-xs text-muted-foreground mb-2">
              {duration?.description}
            </div>
            <div className="text-sm font-semibold text-foreground">
              {duration?.priceRange}
            </div>
            {formData?.duration === duration?.value && (
              <Icon name="CheckCircle2" size={16} color="var(--color-primary)" className="mx-auto mt-2" />
            )}
          </button>
        ))}
      </div>
    </QuestionCard>
  );
};

export default DurationStep;